module.exports = __webpack_public_path__ + "img/lc@2x.4cda3aed.png";